<ion-card-header *ngIf="title">
  <div class="titleWrapper">
    <ion-card-title [color]="color">{{ title }}</ion-card-title>
    <ion-icon [id]="addTriggerID" *ngIf="showAdd" name="add" (click)="addClicked.emit()"></ion-icon>
  </div>
  <ion-label *ngIf="description">
    <p>{{description}}</p>
  </ion-label>
</ion-card-header>
